import React, { useEffect, useState } from 'react'
import {
    Grid
} from '@material-ui/core'
import { getClientData, getClientPoints } from '../firebase/obj/client'
import { getClientAdresses } from '../firebase/obj/clientAddress'
import { CircularProgress } from '@material-ui/core'
import ClientForm from '../components/clientForm/public'
import { logOut } from '../firebase/login'
import useMainContext from '../hooks/useMainContext'


export const MyAccountWithData = () => {
    const { user, config } = useMainContext()
    const [client, setClient] = useState(null)
    const [addresses, setAddresses] = useState([])

    useEffect(() => {
        user && loadData()
    }, [user])

    const loadData = () => {
        const { uid } = user || {}
        if (!uid)
            return
        const p1 = getClientData(uid)
        const p2 = getClientPoints(uid)
        Promise.all([p1, p2]).then(values => {
            const client = values[0]
            const clientPoints = values[1]
            setClient({ ...client, photoURL: user.photoURL, points: clientPoints.points, phoneNumber: user.phoneNumber })
            getClientAdresses(uid).then(list => setAddresses(list))
        }).catch(err => {
            setTimeout(() => loadData(user), 1000)
        })
    }


    if (client)
        return (<ClientForm logOut={logOut} selectedClient={client} addresses={addresses} config={config} />)

    return (
        <Grid container direction="column" justify="center" alignItems="center" style={{ height: '70vh' }}>
            <Grid item>
                <CircularProgress style={{ color: '#662d91' }} />
            </Grid>
        </Grid>
    )
}

export default MyAccountWithData
